var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"ds-text",class:[
    _vm.size && ("ds-text-size-" + _vm.size),
    _vm.color && ("ds-text-" + _vm.color),
    _vm.bold && "ds-text-bold",
    _vm.inline && "ds-text-inline"
  ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }